import React from 'react'
import ContentfulJsonLdBlocks from '../../src/components/shared/ContentfulJsonLdBlocks'
import Layout from '../../src/components/layouts'
import defaultSEO from '../../src/common/constants/nextSEO'
import { data } from '../../src/components/pages/Home/consts'
import HomePage from '../../src/components/pages/Home/default'
import WithSeoOverrides from 'src/components/shared/WithSeoOverride'
import { getHomePageData } from 'src/common/getHomePageData'
import { getMegamenuData } from 'src/common/back/megamenu'
import logger from 'src/common/logger'
import {
  trustMarkerEntryLink,
  trustMarkerEntryRatingNumber,
  trustMarkerEntryTotalReviewNumber,
} from 'src/common/trustMarkerEntryFields'

export async function getServerSideProps(context) {
  const preview = context?.preview ?? false

  const {
    cfosData,
    trustMarker,
    trustMarkersCombination,
    trustPilotInfo: trustPilot,
    outageBanner,
    jsonLdSchemas,
  } = await getHomePageData(preview, {
    combinationId: 'control',
    jsonLdPath: '/',
    trustMarkerFromTrustPilotEntry: true,
  })

  const tpRating = trustMarkerEntryRatingNumber(trustPilot)
  const tpTotal = trustMarkerEntryTotalReviewNumber(trustPilot)

  let megamenuData = null
  try {
    megamenuData = await getMegamenuData(context)
  } catch (error) {
    logger.error('Experiment control: megamenu', { error })
  }

  return {
    props: {
      jsonLdSchemas,
      homeVariation: 'control',
      cfosData,
      trustMarkersCombination: trustMarkersCombination || null,
      trustPilotInfo: trustPilot
        ? {
            ...trustPilot,
            rating: tpRating,
            totalReview: tpTotal,
            link: trustMarkerEntryLink(trustPilot),
          }
        : {},
      trustMarker,
      outageBanner: outageBanner || null,
      megamenuData: megamenuData || null,
    },
  }
}

// Control page
const Control = (pageProps) => {
  const {
    homeVariation,
    cfosData,
    trustMarkersCombination,
    trustPilotInfo,
    outageBanner,
    megamenuData,
  } = pageProps

  return (
    <>
      <WithSeoOverrides {...defaultSEO} />
      <ContentfulJsonLdBlocks jsonLdSchemas={pageProps.jsonLdSchemas} />
      <Layout
        isBrandPage={true}
        isHome={true}
        homeVariation={homeVariation}
        forceFullRequest={true}
        outageBanner={outageBanner}
        megamenuData={megamenuData}
      >
        <HomePage
          data={{
            ...data,
            heroPersonV2: {
              description: `Actual client of Freedom Debt Relief.\nIndividual results are not typical and will vary.`,
            },
            heroBanner: {
              ...data.heroBanner,
              content: {
                title: 'Get rid of credit card debt',
                sliderTitle: 'How much do you owe?',
                buttonText: 'Continue',
              },
            },
            showBarChart: true,
            cfosData,
            isCfosDisclousuresVariationActive: true,
            trustMarkersCombination,
            useTestimonialFormat: true,
            trustPilotInfo,
          }}
        />
      </Layout>
    </>
  )
}

export default Control
